import styled from 'styled-components';

const Card = styled.div`
  width: 100%;
  position: relative;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: white;
  overflow: hidden;
  min-height: calc(100vh);
  text-align: center;
  padding-top: 110px;
  display: flex;
  justify-content: center;
`;

export default Card;